export function LogoGraySmall({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='72' height='60' viewBox='0 0 72 60' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g opacity='0.25'>
        <path
          d='M10.4423 0C15.9263 0 20.3757 4.51246 20.3757 10.0743V35.9947C20.3757 41.5566 15.9263 46.069 10.4423 46.069C4.95823 46.069 0.508911 41.5566 0.508911 35.9947V10.0743C0.508911 4.51246 4.95823 0 10.4423 0Z'
          fill='url(#paint0_linear_2080_38762)'
        />
        <path
          d='M36 13.9309C41.4841 13.9309 45.9334 18.4434 45.9334 24.0053V49.9257C45.9334 55.4875 41.4841 60 36 60C30.516 60 26.0667 55.4875 26.0667 49.9257V24.0053C26.0667 18.4434 30.516 13.9309 36 13.9309Z'
          fill='url(#paint1_linear_2080_38762)'
        />
        <path
          d='M61.5578 1.07565C67.0418 1.07565 71.4911 5.58811 71.4911 11.15V46.6725C71.4911 52.2343 67.0418 56.7468 61.5578 56.7468C56.0737 56.7468 51.6244 52.2343 51.6244 46.6725V11.15C51.6244 5.58811 56.0737 1.07565 61.5578 1.07565Z'
          fill='url(#paint2_linear_2080_38762)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_2080_38762'
          x1='24.4628'
          y1='-10.6515'
          x2='-1.55341'
          y2='50.1615'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6B7280' />
          <stop offset='1' stopColor='#F3F4F6' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2080_38762'
          x1='50.0206'
          y1='3.2532'
          x2='24.0043'
          y2='64.0662'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4B5563' />
          <stop offset='1' stopColor='#E5E7EB' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2080_38762'
          x1='72.7069'
          y1='4.82729'
          x2='46.3685'
          y2='60.1342'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#374151' />
          <stop offset='1' stopColor='#D1D5DB' />
        </linearGradient>
      </defs>
    </svg>
  )
}
